import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [practiceData, setPracticeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDemo, setIsDemo] = useState(false);

  async function signup(email, password, practiceName) {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    await setDoc(doc(db, 'practices', result.user.uid), {
      practiceName,
      email,
      phone: '',
      createdAt: new Date().toISOString(),
    });
    return result;
  }

  async function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  async function logout() {
    if (isDemo) {
      setIsDemo(false);
      setCurrentUser(null);
      setPracticeData(null);
      return;
    }
    return signOut(auth);
  }

  function enterDemo() {
    setIsDemo(true);
    setCurrentUser({ uid: 'demo', email: 'demo@recallready.com' });
    setPracticeData({ practiceName: 'Bright Smiles Dental', phone: '+65 6123 4567' });
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        try {
          const snap = await getDoc(doc(db, 'practices', user.uid));
          if (snap.exists()) setPracticeData(snap.data());
        } catch (e) {
          console.error(e);
        }
      } else {
        setPracticeData(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = { currentUser, practiceData, setPracticeData, isDemo, login, signup, logout, enterDemo };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
